import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

export interface IPopoverMessage {
  message: string;
  id: number;
}
@Injectable()
export class PopoverService {
  $popoverStream: BehaviorSubject<IPopoverMessage | null> =
    new BehaviorSubject<IPopoverMessage | null>(null);
  constructor() {}

  public get popoverMessage() {
    return this.$popoverStream.asObservable();
  }

  public popMessage(str: string) {
    const id = Math.floor(Math.random() * 100000);
    this.$popoverStream.next({ message: str, id });
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/popover.service.ts